export const toTitleCase = (str: string) =>
    str.replace(/\w*/g, (word) => word.charAt(0).toUpperCase() + word.substr(1).toLowerCase());
